import Followers from "./Followers/Followers";
import Following from "./Following/Following";

export default [
	{
		key: "userpanelFriendsFollowing",
		component: Following,
		path: "/userpanel/following/following/:page?",
		link: "/userpanel/following/following",
	},
	{
		key: "userpanelFriendsFollowers",
		component: Followers,
		path: "/userpanel/following/followers/:page?",
		link: "/userpanel/following/followers",
	},
];
